import { factoryService, postJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_BUYER_URL } from '../config/settings/environment'

/**
 * Gets the result search buyer by org legal name.
 */
export const getSearchBuyerByOrgLegalName = factoryService(({ orgLegalName, page, size }) => {
  const body = {
    nombre: orgLegalName,
    page,
    size
  }

  return postJsonRequest(`${REACT_APP_API_BASE_BUYER_URL}/compradores/busqueda/razonsocial`, { body })
})

/**
 * Gets the result search buyer by dni.
 */
export const getSearchBuyerByRut = factoryService(({ dni, page, size }) => {
  const body = {
    nombre: dni,
    page,
    size
  }

  return postJsonRequest(`${REACT_APP_API_BASE_BUYER_URL}/compradores/busqueda/rut`, { body })
})
